import { api } from '@/api/client';
// import type {
//   TransactionApiResponse,
// } from '@/pages/merchant/Transactions/types';

// Transaction API endpoints
const TRANSACTION_ENDPOINTS = {
  LIST: '/merchant/v1/transactions/',
  FILTER: '/merchant/v1/transactions/',
  INITIATE_PAYMENT: '/merchant/v1/internal/initiate-payment/',
  // CREATE: '/merchant/v1/transactions/',
  // UPDATE: (id: string) => `/merchant/v1/transactions/${id}/`,
  // DELETE: (id: string) => `/merchant/v1/transactions/${id}/`,
  STATS: '/merchant/v1/transactions/stats/',
  // EXPORT: '/merchant/v1/transactions/export/',
} as const;

// Query parameters interface for list endpoint
export interface TransactionListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  payment_gateway?: string;
  start_date?: string;
  end_date?: string;
  min_amount?: number;
  max_amount?: number;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
}

class TransactionService {
  /**
   * Get paginated list of transactions
   */
  async getTransactions(page: number = 1, pageSize: number = 50): Promise<any> {
    try {
      const url = `${TRANSACTION_ENDPOINTS.LIST}`;
      const response = await api.get<any>(url, {
        params: {
          page: page,
          page_size: pageSize,
        },
      });

      return response;

    } catch (error) {
      throw this.handleError(error, 'Failed to fetch transactions');
    }
  }

  /**
   * Get single transaction by ID
   */
  async getTransactionData(id?: string, merchantTransactionId?: string): Promise<any> {
    try {
      if (!id && !merchantTransactionId) {
        throw new Error('Either transaction_id or merchant_transaction_id must be provided');
      }

      const queryParams = new URLSearchParams();

      if (id) {
        queryParams.append('transaction_id', id);
      }

      if (merchantTransactionId) {
        queryParams.append('merchant_transaction_id', merchantTransactionId);
      }

      const url = `${TRANSACTION_ENDPOINTS.FILTER}?${queryParams.toString()}`;
      const response = await api.get<{ data: any }>(url);
      return response;
    } catch (error) {
      throw this.handleError(error, 'Failed to fetch transaction');
    }
  }


  /**
 * Get single transaction by ID
 */
  async getTransactionStatusData(status?: string): Promise<any> {
    try {
      if (!status) {
        throw new Error('Either status must be provided');
      }

      const queryParams = new URLSearchParams();

      if (status) {
        queryParams.append('transaction_status', status);
      }

      const url = `${TRANSACTION_ENDPOINTS.FILTER}?${queryParams.toString()}`;
      const response = await api.get<{ data: any }>(url);
      return response;
    } catch (error) {
      throw this.handleError(error, 'Failed to fetch transaction');
    }
  }

  /**
   * Initiate a payment by transaction amount
   */
  async initiatePayment(transactionAmount: string): Promise<any> {
    try {
      const payload = { transaction_amount: transactionAmount } as const;
      const response = await api.post<any>(TRANSACTION_ENDPOINTS.INITIATE_PAYMENT, payload);
      return response;
    } catch (error) {
      throw this.handleError(error, 'Failed to initiate payment');
    }
  }

  // /**
  //  * Create new transaction
  //  */
  // async createTransaction(data: CreateTransactionRequest): Promise<Transaction> {
  //   try {
  //     const response = await api.post<{ data: Transaction }>(TRANSACTION_ENDPOINTS.CREATE, data);
  //     return response.data.data;
  //   } catch (error) {
  //     throw this.handleError(error, 'Failed to create transaction');
  //   }
  // }

  // /**
  //  * Update existing transaction
  //  */
  // async updateTransaction(id: string, data: UpdateTransactionRequest): Promise<Transaction> {
  //   try {
  //     const response = await api.put<{ data: Transaction }>(TRANSACTION_ENDPOINTS.UPDATE(id), data);
  //     return response.data.data;
  //   } catch (error) {
  //     throw this.handleError(error, 'Failed to update transaction');
  //   }
  // }

  // /**
  //  * Delete transaction
  //  */                                                                                                nc deleteTransaction(id: string): Promise<void> {
  //   try {
  //     await api.delete(TRANSACTION_ENDPOINTS.DELETE(id));
  //   } catch (error) {
  //     throw this.handleError(error, 'Failed to delete transaction');
  //   }
  // }

  /**
   * Get transaction statistics
   */
  async getTransactionStats(): Promise<any> {
    try {
      const response = await api.get<any>(TRANSACTION_ENDPOINTS.STATS);
      return response;
    } catch (error) {
      throw this.handleError(error, 'Failed to fetch transaction statistics');
    }
  }

  // /**
  //  * Export transactions
  //  */
  // async exportTransactions(params: TransactionListParams = {}, format: 'csv' | 'xlsx' = 'csv'): Promise<Blob> {
  //   try {
  //     const queryParams = new URLSearchParams();

  //     // Add all params
  //     Object.entries(params).forEach(([key, value]) => {
  //       if (value !== undefined && value !== null) {
  //         queryParams.append(key, value.toString());
  //       }
  //     });

  //     queryParams.append('format', format);

  //     const url = `${TRANSACTION_ENDPOINTS.EXPORT}?${queryParams.toString()}`;
  //     const response = await api.get<Blob>(url, {
  //       responseType: 'blob',
  //     });

  //     return response.data;
  //   } catch (error) {
  //     throw this.handleError(error, 'Failed to export transactions');
  //   }
  // }

  /**
   * Handle API errors
   */
  private handleError(error: unknown, defaultMessage: string): Error {
    if (error && typeof error === 'object' && 'message' in error) {
      return error as Error;
    }
    return new Error(defaultMessage);
  }
}

// Create singleton instance
export const transactionService = new TransactionService();

// Export for testing
export { TransactionService };

